// extracted by mini-css-extract-plugin
export default {"root":"WebhooksEmptyTable_root__JEUPx","iconWrapper":"WebhooksEmptyTable_iconWrapper__i9VWP"};